module.exports = __webpack_public_path__ + "img/product-preview-84.3fbf4d8.png";